import React from 'react';
import { useState } from 'react';
import Rodal from 'rodal';
import { IApplication } from '../types';

type CreateEnrollmentModalProps = {
  show: boolean,
  application: IApplication,
  onCreate: () => Promise<void>
  onClose: () => void
}

const CreateEnrollmentModal = ({ show, onCreate, onClose, application }: CreateEnrollmentModalProps) => {
  const [loading, setLoading] = useState(false);

  const handleCreateEnrollment = () => {
    setLoading(true);

    onCreate().finally(() => setLoading(false))
  }

  return (
    <Rodal
      closeOnEsc
      width={600}
      height={300}
      visible={show}
      onClose={onClose}
    >
      <div className="d-flex flex-column h-100">
        <div className="modal-header">
          <div className="text-center">
            <h2>Criar matricula.</h2>
          </div>
        </div>
        <div className="modal-body">
          Deseja criar a matricula do candidato {application.real_name} para o {application.deferred_onboarding && application.deferred_onboarding.field_step}º Período? Essa ação não poderá ser desfeita.
        </div>
        <div className="modal-footer">
          <button
            type="button"
            disabled={loading}
            onClick={onClose}
            className="btn-danger btn blue"
          >
            Cancelar
          </button>
          <button
            type="button"
            disabled={loading}
            onClick={handleCreateEnrollment}
            className="btn-primary btn blue"
          >
            Criar
          </button>
        </div>
      </div>
    </Rodal>
  )
}

export default CreateEnrollmentModal;
